var screen_width = $( window ).width();

if(screen_width < 991){
$('.Menu_list li.li-lists span.pls').on('click', function () {
    $(this).parents('.li-lists').find('.showMob-dd').slideToggle();
	$(this).parents('.li-lists').siblings('.li-lists').find('.showMob-dd').slideUp();
    $(this).toggleClass('active');
	$(this).parents('.li-lists').siblings('.li-lists').find('span.pls').removeClass('active');;
});

$('.Menu_list li.li-lists a.pls').on('click', function () {
    $(this).parents('.li-lists').find('.showMob-dd').slideToggle();
	$(this).parents('.li-lists').siblings('.li-lists').find('.showMob-dd').slideUp();
    $(this).parent('.li-lists').find('span.pls').toggleClass('active');
	$(this).parents('.li-lists').siblings('.li-lists').find('span.pls').removeClass('active');;
});
}	
	//menu-full
$(function(){
  $('a.mobile-trigger').on('click', function(){
      $('body').toggleClass('mobile-open');
	  $('.hdr-search').slideUp();
  }) 

 $('.Fullmenu-bar .close_nav').on('click', function() {
    $('.Fullmenu-bar').removeClass('full_menu');
    $('body').removeClass('mobile-open');
  })
  
  $('.closeOfferStrip').on('click', function() {
    $('.header-top').slideUp();
  })
  
	$(function() {
		$('.middle-box a[href*=\\#]:not([href=\\#])').on('click', function() {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - 70
				}, 1000);
				return false;
			}
		});
	});
    
});



if( $(window).width() < 991 ){
	$(document).click(function(e){
	  if(!$(e.target).is('a.mobile-trigger, a.mobile-trigger *, .Fullmenu-bar, .Fullmenu-bar *, a.mobile-trigger-c, a.mobile-trigger-c *')){
		$('.Fullmenu-bar').removeClass('full_menu');
		$('body').removeClass('mobile-open');
	  }
	});
}
 
//video on

$('.one').click(function(){
   document.getElementById('videoPlayer').play();
   $(this).hide();
});


$('.two').click(function(){
   document.getElementById('videoPlayer1').play();
   $(this).hide();
});


$('.three').click(function(){
   document.getElementById('videoPlayer2').play();
   $(this).hide();
});

$('.four').click(function(){
   document.getElementById('videoPlayer3').play();
   $(this).hide();
});

         

//loader page
$(window).on('load', function() {
    $('#ctn-preloader').fadeOut();
    $('#preloader').delay(350).fadeOut('slow');
    $('body').delay(350).css({
        'overflow': 'visible'
    });
});

function loader() {
    $(window).on('load', function() {
        $('#ctn-preloader').addClass('loaded');
        if ($('#ctn-preloader').hasClass('loaded')) {
            $('#preloader').delay(900).queue(function() {
                $(this).remove();
            });
        }
    });
}
loader();
  

  $('#thelook.owl-carousel').owlCarousel({
		center: true,
      	autoplay: true, 
      	autoPlaySpeed:3000,
	 	autoplayTimeout:8000, 
        loop:true,
		margin:10,		
        nav:true,  
		responsive:{
			0:{
				items:2
			},
			480:{
            items:2
        },
			 600:{
            items:3
        },
			1000:{
				items:5
			}
		}
	});

 
 



 $('.owl-carousel').owlCarousel({
   		center: true,
		loop:true,
        autoplay: true, 
		animateOut: 'fadeOut',
        autoPlaySpeed:4500,
		autoplayTimeout:8000,
 
		nav:false,
		responsive:{
			0:{
				items:1
			},
			1000:{
				items:1
			}
		}
	});

//Header_fix
if($(window).width()>991){
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 180) {
      $('header').addClass('fix_active');
    } else {
      $('header').removeClass('fix_active');
    }
  })
}


	

  
//mobile-menu
$(function(){

$('.hamburger-menu').on('click', function(){
  $('html').addClass('Bg-open');
    $(".burger-1, .burger-2, .burger-3").addClass("open");
    if ($('.Menu_list').hasClass('mobileOpen'))
    {
    $('.Menu_list').removeClass('mobileOpen');
    $(".burger-1, .burger-2, .burger-3").removeClass("open");
    $('html').removeClass('Bg-open');
    }
    else{
    $('.Menu_list').addClass('mobileOpen');
    }
  });
});


$(document).click(function(e){
  if(!$(e.target).is('.hamburger-menu, .hamburger-menu *, .Menu_list, .Menu_list *')){
    $('.Menu_list').removeClass('mobileOpen');
    $(".burger-1, .burger-2, .burger-3").removeClass("open");
    $('html').removeClass('Bg-open');
  }
});


 